import React, { useState } from "react";
import { login } from "./api";
import { isCapacitorClient } from "./refreshStorage";
import { clearAllLocalData } from "modules/offline/clearLocalData";

const Login = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);
  const [clearing, setClearing] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setPending(true);
    setError(null);
    try {
      await login(email, password);
      if (onSuccess) {
        await onSuccess();
      } else {
        window.location.assign("/");
      }
    } catch (err) {
      setError(_.get(err, "response.data.error") || err.message || "Login failed");
    } finally {
      setPending(false);
    }
  };

  const microsoftLogin = (e) => {
    e.preventDefault();
    if (isCapacitorClient()) {
      // WebView is https://localhost and has no Rails CSRF session. The system browser does.
      const apiBase = (import.meta.env.VITE_API_URL || "").replace(/\/$/, "");
      if (!apiBase) {
        setError("Microsoft sign-in is unavailable");
        return;
      }
      window.location.assign(`${apiBase}/auth/microsoft`);
      return;
    }
    // OmniAuth CSRF form POST
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/users/auth/microsoft_office365";
    const csrf = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");
    if (csrf) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "authenticity_token";
      input.value = csrf;
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
  };

  const clearLocalData = async () => {
    if (!window.confirm("Remove cached records and unsynced work on this device?")) return;
    setClearing(true);
    try {
      await clearAllLocalData();
      window.location.assign("/");
    } catch (_e) {
      setClearing(false);
      setError("Could not clear local data");
    }
  };

  return (
    <div className="container" style={{ paddingTop: "10vh" }}>
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="card-group justify-content-center">
            <div
              className="card"
              style={{
                maxWidth: 430,
                border: "1px solid #e5f0f5",
                boxShadow:
                  "0 0.46875rem 2.1875rem rgb(8 10 37 / 3%), 0 0.9375rem 1.40625rem rgb(8 10 37 / 3%), 0 0.25rem 0.53125rem rgb(8 10 37 / 5%), 0 0.125rem 0.1875rem rgb(8 10 37 / 3%)",
              }}
            >
              <div className="card-body">
                <form id="login-form" onSubmit={submit}>
                  <div className="row">
                    <div className="col-md-12">
                      <img src="/images/login-logo-new.png" className="login-logo" alt="Lion" style={{ display: "block", margin: "0 auto 2rem" }} />
                    </div>
                  </div>
                  <label htmlFor="email" style={{ textTransform: "uppercase", color: "#999", fontSize: 12 }}>Email</label>
                  <div className="input-group mb-3">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="form-control"
                      style={{ height: 41, borderRadius: "0.25rem" }}
                      autoFocus
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <label htmlFor="password" style={{ textTransform: "uppercase", color: "#999", fontSize: 12 }}>Password</label>
                  <div className="input-group mb-3">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      className="form-control"
                      style={{ height: 41, borderRadius: "0.25rem" }}
                      autoComplete="off"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}
                  <div className="row">
                    <div className="col-12 mt-3">
                      <button type="submit" className="btn btn-primary px-4" style={{ width: "100%" }} disabled={pending}>
                        {pending ? "Logging in…" : "Log in"}
                      </button>
                    </div>
                  </div>
                </form>
                {window.location.protocol === "https:" && (
                  <>
                    <div className="row">
                      <div className="col-12 text-center mt-3" style={{ color: "#999", fontSize: 14 }}>
                        OR
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 mt-4 text-center mb-4">
                        <button type="button" onClick={microsoftLogin} style={{ border: "none", background: "transparent", padding: 0 }}>
                          <img src="/images/microsoft-sign-in.png" alt="Sign in with Microsoft" />
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {isCapacitorClient() && (
                  <div className="row">
                    <div className="col-12 mt-3 text-center">
                      <button
                        type="button"
                        className="btn btn-link"
                        style={{ color: "#999", fontSize: 13, textDecoration: "underline" }}
                        onClick={clearLocalData}
                        disabled={clearing || pending}
                      >
                        {clearing ? "Clearing…" : "Clear local data"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
